var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{attrs:{"id":"demo"}},[_c('treeItem',{staticClass:"item documentation-menu",attrs:{"item":_vm.itemsTree}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }